export function validate_decnum_orempty(value) {
    if (parseFloat(value)<0) {
        value=value*(-1);
        value+="";
    }
    if (parseFloat(value)>0) { 
        return parseFloat(strToFloatStr(value));
    }
    if (value=="") return "0";
    if (value.trim()=="") return "0";
    if (parseFloat(value)==0) return "0";
    if (parseFloat(strToFloatStr(value)==0)) return "0";
    if (parseFloat(value)!=0 && !parseFloat(value)>0 && !parseFloat(strToFloatStr(value)==0)) {
        return false;
    }
}

export function validate_decnum_nonempty(value) {
    if (parseFloat(value)<0) {
        value=value*(-1);
        value+="";
    }
    if (parseFloat(value)>0) { 
        return parseFloat(strToFloatStr(value));
    }
    if (value=="") return false;
    if (value.trim()=="") return false;
    if (parseFloat(value)==0) return "0";
    if (parseFloat(strToFloatStr(value)==0)) return "0";
    if (parseFloat(value)!=0 && !parseFloat(value)>0 && !parseFloat(strToFloatStr(value)==0)) {
        return false;
    }
}

export function validate_mmyy_date(value) {
    if (!value.toString()) return false;
    value = value.toString();
    if (value.length>5 || value.length < 5) return false;
    if (value[2] != "/") return false;
    if(!parseInt(value[0]+value[1])) return false;
    if(parseInt(value[0]+value[1])<1 || parseInt(value[0]+value[1])>12) return false;
    if(!parseInt(value[3]+value[4])) return false;
    return true;
}

export function validate_nonzero(val) {
    if (val === undefined || val == null || val.length == 0) return false;
    try {
        if (parseFloat(val)<=0) return false; 
    } catch(e) {
        return false;
    } 
    return val;
}

export function validate_notEmptyString(val) {
    if (val.toString().length>0) { return true }
    else { return false }
}

export function roundTo(v, d) { return parseFloat(Math.round(parseFloat(v).toFixed(d + 1) + 'e' + d) + 'e-' + d).toFixed(d) };

export function strToFloatStr(str) {
    str = str.toString().trim();
    // only digits, comma and dot are allowed, otherwise return false immediately
    if (!/^[\d.,]+$/.test(str)) return false;

    // decide which separator is the decimal one
    var lastComma = str.lastIndexOf(',');
    var lastDot = str.lastIndexOf('.');
    var decimalSep = null;

    if (lastComma !== -1 && lastDot !== -1) {
        // both present -> the later occurring separator is the decimal one
        decimalSep = lastComma > lastDot ? ',' : '.';
    } else if (lastComma !== -1 || lastDot !== -1) {
        var sep = lastComma !== -1 ? ',' : '.';
        var parts = str.split(sep);
        if (parts.length > 2) {
            // appears multiple times -> it is a thousands separator (e.g. 1.000.000)
            decimalSep = null;
        } else {
            // single occurrence -> decimal only if the trailing group is NOT exactly 3 digits
            // (a lone "10.500" / "10,500" is treated as thousands => 10500)
            decimalSep = parts[1].length === 3 ? null : sep;
        }
    }

    if (decimalSep) {
        var thousandSep = decimalSep === ',' ? '.' : ',';
        return str.split(thousandSep).join('').replace(decimalSep, '.');
    }
    // no decimal separator -> every separator is a thousands separator
    return str.replace(/[.,]/g, '');
}

export function validate_single_input(jqelem) {
    var validation = false;
    if (jqelem.attr("data-validation") == "not-nan-not-empty") {
        if (jqelem.val().length>0 && !isNaN(jqelem.val()))
            validation = true;
    }
    if (jqelem.attr("data-validation") == "non-empty") {
        if (jqelem.val().length>0)
            validation = true;
    }
    if (jqelem.attr("data-validation") == "mmyy-date") {
        validation = validate_mmyy_date(jqelem.val());
    }
    if (jqelem.attr("data-validation") == "dec-num-not-empty") {
        validation = validate_decnum_nonempty(jqelem.val());
    }
    
    if (validation) {
        if (jqelem.hasClass('invalid-input')) {
            jqelem.removeClass("invalid-input");
        }
        $(document).find($("."+jqelem.attr("data-error"))).each(function() {
            $(this).css("opacity", "0");
        });
    }

    if (!validation) {
        if (!jqelem.hasClass('invalid-input')) {
            jqelem.addClass("invalid-input");
        }
        $(document).find($("."+jqelem.attr("data-error"))).each(function() {
            $(this).css("opacity", "1");
        })
    }
   return validation;
}

export function addAllInputChangeDetections() {
    /* Set text of all feedbacks */
    $('.invalid-feedback').each(function() {
        var classList = $(this).attr('class').split(/\s+/);
        $.each(classList, function(index, item) {
            if (parseInt(item)) {
                $("."+item).html(errorcodes[item]);
            }
        });
    })
    $('.input-group-text').on('change', function () {
        var jqelem = $(this);
        if (jqelem.attr("data-validation") && jqelem.attr("data-error")) 
            validate_single_input(jqelem);  
    });
}

export function removeAllInputChangeDetections() {
    $('.input-group-text').each(function() {
        $(this).off();
    });
}